import { formatCurrency, formatRut } from '../../../../../utils/formatter'
import ModalConciliacionRemuneracion from './ModalConciliar/ModalConciliacionRemuneracion'
import { Text } from '../../../../ui'
import { useState } from 'react'
import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const isInvalidWorkerName = value => {
  const normalized = String(value ?? '').trim().toLowerCase()
  return normalized === '' || normalized === 'undefined' || normalized === 'null'
}

const SubTableRRHH = ({ data = [] }) => {
  const [openEdit, setOpenEdit] = useState(false)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const showNombreTrabajadorColumn = data.some(row => !isInvalidWorkerName(row?.nombreTrabajador))
  //const handleClick = () => { setOpenEdit(true) }

  if (isMobile) {
    return (
      <div className="space-y-2 font-sans">
        {data.map((row, index) => (
          <div key={index} className="rounded-xl border border-gray-100 bg-white p-3 shadow-sm">
            {!isInvalidWorkerName(row?.nombreTrabajador) && (
              <Text className="text-xs font-semibold">{row.nombreTrabajador}</Text>
            )}
            <Text className="text-[11px] text-gray-500">
              {(row.rutTrabajador && formatRut(row.rutTrabajador)) || '<RUT>'}
            </Text>
            <div className="mt-2 grid grid-cols-2 gap-2 text-xs">
              <div>
                <Text className="text-[10px] text-gray-400">Fecha</Text>
                <Text className="text-xs font-semibold">{row.query}</Text>
              </div>
              <div className="text-right">
                <Text className="text-[10px] text-gray-400">Monto Liquido</Text>
                <Text className="text-xs font-semibold">{formatCurrency(row.sueldoLiquido)}</Text>
              </div>
            </div>
            <Text className="mt-2 text-[11px] text-gray-500">Remuneraciones</Text>
          </div>
        ))}
        {openEdit && (
          <ModalConciliacionRemuneracion open={openEdit} setOpen={setOpenEdit}/>
        )}
      </div>
    )
  }

  return (
    <div className="overflow-x-auto font-sans">
      <table className="w-full text-xs text-left border-collapse font-sans">
        <thead className="bg-gray-100 items-center justify-center">
          <tr className='text-center'>
            {/*<th className="p-2 border">Folio</th>*/}
            {showNombreTrabajadorColumn && <th className="p-2 border">Trabajador</th>}
            <th className="p-2 border">Rut</th>
            <th className="p-2 border">Fecha</th>
            <th className="p-2 border">Tipo Movimiento</th>
            <th className="p-2 border">Monto Liquido</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index} className="border-b text-center">
              {showNombreTrabajadorColumn && (
                <td className="font-bold text-[0.65rem] p-2 border">
                  <Text>{isInvalidWorkerName(row?.nombreTrabajador) ? '' : row.nombreTrabajador}</Text>
                </td>
              )}
              <td className="font-bold text-[0.65rem] p-2 border">
                <Text>{(row.rutTrabajador && formatRut(row.rutTrabajador)) || '<RUT>'} </Text>
              </td>
              <td className="font-bold text-[0.65rem] p-2 border">{row.query}</td>
              <td className="font-bold text-[0.65rem] p-2 border">Remuneraciones</td>
              <td className="font-bold text-[0.65rem] p-2 border">
                <Text>{formatCurrency(row.sueldoLiquido)}</Text>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {openEdit && (
        <ModalConciliacionRemuneracion open={openEdit} setOpen={setOpenEdit}/>
      )}
    </div>
  )
}

export default SubTableRRHH
